import Footer from "./footer/footer";
import Header from "./header/header";
import Content from "./content/content";
import { memo, useContext } from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchMessages, overwriteState } from "redux/slices/main";
import InitializeContext from "context/initialize-context";
import { checkPermission } from "utils";

const PanelLayer = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const enums = useContext(InitializeContext);

    const authorizationProcess = useSelector(state => state.main.authorizationProcess);
    const authorization = useSelector(state => state.main.authorization);
    const info = useSelector(state => state.main.info);

    useEffect(() => {
        if (authorizationProcess) {
            if (authorization) {
                if (checkPermission(["/api/message/list"], enums.permissions))
                    dispatch(fetchMessages());
                else
                    dispatch(overwriteState({
                        messages: {
                            fetched: true,
                            error: false,
                            data: {},
                            noPermission: true
                        }
                    }));

                const profileRoute = "/panel/profile";
                if (info.fetched && Object.keys(info.shop).length === 0 && location.pathname !== profileRoute)
                    navigate(profileRoute, { replace: true });
            } else
                navigate("/auth/login", { replace: true });
        }

        // eslint-disable-next-line
    }, [authorizationProcess, authorization, location.pathname, enums]);

    return (
        info.fetched && authorization && Object.keys(enums.permissions)?.length ? (
            <>
                <Header />
                <Content />
                <Footer />
            </>
        ) : <></>
    )
}

export default memo(PanelLayer);